import { render, staticRenderFns } from "./TransProPrice.vue?vue&type=template&id=a29210d4&scoped=true&"
import script from "./TransProPrice.vue?vue&type=script&lang=js&"
export * from "./TransProPrice.vue?vue&type=script&lang=js&"
import style0 from "./TransProPrice.vue?vue&type=style&index=0&id=a29210d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29210d4",
  null
  
)

export default component.exports